/* eslint-disable react/prop-types */
import React from "react";
import AppLoading from "core/components/loading";

function Callback() {
  return <AppLoading loading={true} description={"Đang tải trang..."} />;
}

export default Callback;
